module.exports = __webpack_public_path__ + "static/media/hm2.ce97369b.PNG";